import React, { Component } from 'react';
import { MemoryRouter,Switch,Route,Redirect,withRouter} from "react-router-dom";
import {TabBar} from 'app/components/Basics';
import GlobalControlLine from './components/GlobalControlLine/GlobalControlLineComponent';
import GlobalFieldLine from './components/GlobalFieldLine/GlobalFieldLineComponent';
import {HoneypotSetFormContext} from './HoneypotSetContext'
import HoneypotSetService from "app/services/honeypotSet.service";
import  GetErrorMessage  from 'app/helpers/error-message'
import {ShowError, ShowSuccess} from "app/components/toast"
import NewHoneypotSet from './models/HoneypotSetModel';
import Modal from 'app/components/Modal';
import cloneDeep from 'lodash/cloneDeep';
import TabQuestions from './components/TabQuestions/TabQuestionsComponent';
import isEqual from 'lodash/isEqual';
import ValidateHoneypotSet from './HoneypotSetValidation'

class HoneypotSetForm extends Component {
    tabs = [];	
    constructor(props){
        super(props);
        this.state = {           
            activeTab:'questions',
            selectedHoneypotSet: NewHoneypotSet(),
            errors: []		
        }
    }

    getTabs(){        
        return [
            { id:"questions", label: 'Questions', url: 'questions', disabled:false, error:false},            
        ];
    }

	componentWillReceiveProps(nextProps) {
		if (nextProps.selectedHoneypotSet != null) {
			this.setState({ 
				selectedHoneypotSet: nextProps.selectedHoneypotSet,
				activeTab: "questions"
			});
		}	

        if (!isEqual(this.props.selectedHoneypotSet, nextProps.selectedHoneypotSet)) {
            this.setState({errors: []});            
        }
    }	

    updateSelectedHoneypotSet(newSelectedHoneypotSet) {
		this.setState({selectedHoneypotSet: newSelectedHoneypotSet})
    }

    addErrorMessage(field, message) {
        var errors = this.state.errors;
        errors.push({ field: field, errorMessage: message});
        this.setState({errors: errors})
    }	

    SaveHoneypotSet(honeypotSet) {
        this.props.toggleUiBlock(true);
        if (honeypotSet.id) {
            HoneypotSetService.updateHoneypotSet(honeypotSet)
                .then(response =>{                    
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The honeypot set was saved successfully' });                    
					this.props.getHoneypotSetById(honeypotSet.id);
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }
        else {
            HoneypotSetService.createHoneypotSet(honeypotSet)
                .then(response => {					
                    const newHoneypotSet = response.data;                    
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The honeypot set was created successfully' });                                        
                    this.setState({selectedHoneypotSet: newHoneypotSet});					
					this.props.getHoneypotSetById(newHoneypotSet.id);
					
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }

    }
    deleteHoneypotSet = event => {        
        this.setState({ deleteQuestionModalText: `Are you sure you want to delete the honeypot set with name '${this.state.selectedHoneypotSet.name}'?`});
    }

    duplicateHoneypotSet = event => {        
        let cloned = cloneDeep(this.state.selectedHoneypotSet);
        cloned.id = null;
        cloned.name = `${cloned.name}_copy`;
		this.props.updateSelectedHoneypotSet(cloned);
    }

    confirmDelete() {        
        this.hideDeleteModal();
        this.props.toggleUiBlock(true);
        const honeypotSetId = this.state.selectedHoneypotSet.id;
        HoneypotSetService.deleteHoneypotSet(this.state.selectedHoneypotSet)
        .then(response =>{            
            this.setState({successMessage: 'The honeypot set was deleted successfully' });            
            this.props.removeDeletedHoneypotSet(honeypotSetId);
			setTimeout(() => {
				this.props.toggleUiBlock(false);
				this.props.closeEditor();				
			}, 2000);

            
        })
        .catch(error => {
            let errorMessage = GetErrorMessage(error);
            console.log("errorMessage on catch");
            console.log(errorMessage);
            this.props.toggleUiBlock(false);
            this.setState({ errorMessage: errorMessage});
        });
    }

    hideDeleteModal() {
        this.setState({deleteQuestionModalText: ''})
    }    

    handleSubmitAction = event => { 
		var validationErrors = ValidateHoneypotSet(this.state.selectedHoneypotSet);
		this.setState({errors: validationErrors});
		if (validationErrors && validationErrors.length === 0) {                    
			this.SaveHoneypotSet(this.state.selectedHoneypotSet);
		}        
        return;
    }

    render() {

        this.tabs = this.getTabs(this.state.selectedHoneypotSet);
        return (        
               
            <div className="AppFormComponent HoneypotSetForm">                 
                <HoneypotSetFormContext.Provider value={{updateSelectedHoneypotSet: this.updateSelectedHoneypotSet.bind(this), selectedHoneypotSet: this.state.selectedHoneypotSet}}>                
                    <form ref={ form => this.formEl = form } onSubmit={ this.handleSubmitAction }>
                        <GlobalControlLine errors={this.state.errors} 
                                handleSubmitAction={this.handleSubmitAction.bind(this)} 
                                deleteHoneypotSet={this.deleteHoneypotSet.bind(this)}
                                duplicateHoneypotSet={this.duplicateHoneypotSet.bind(this)}
                                closeEditorButtonOnClick={this.props.closeEditorButtonOnClick}
								didSelectedHoneypotSetChange={this.props.didSelectedHoneypotSetChange}								
								canChangeData={this.props.canChangeData}
								/>
                        <div className="form-head">
                            <GlobalFieldLine canChangeData={this.props.canChangeData} folders={this.props.folders} key={this.state.selectedHoneypotSet.id} metadata={this.props.metadata}/>
                        </div>
                        <div className="form-sections">
                            <MemoryRouter>
                                <div className="tab-bar">
                                    <TabBar key="HoneypotSetForm" activeTab={this.state.activeTab} tabs={this.tabs} onTabActivate={item=>this.setState({activeTab:item.id})}/>
                                    {/* <div title="Load the current tab settings from another question." className="duplicate-tab"><ButtonIcon icon={DuplicateIcon}/></div> */}
                                </div>
                                <div className="section-content">
                                    <Switch>
                                        <Route exact path="/"><Redirect to={this.state.activeTab}/></Route>
                                        <Route exact path="/questions"><TabQuestions canChangeData={this.props.canChangeData} errors={this.state.errors} /></Route>                                        
                                    </Switch>
                                    <Redirect to={this.state.activeTab}/>
                                </div>
                            </MemoryRouter>
                        </div>
                    </form>                    
                </HoneypotSetFormContext.Provider>

                {this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
                {this.state.successMessage && ( <ShowSuccess clearMessage={() => this.setState({successMessage: ''})} message={this.state.successMessage} /> )}
                {this.state.deleteQuestionModalText && ( <Modal content={this.state.deleteQuestionModalText} size="small" confirmModalHandler={this.confirmDelete.bind(this)} cancelModalHandler={this.hideDeleteModal.bind(this)} />)}				
            </div>            
        );
    }
}
export default withRouter(HoneypotSetForm); 